'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tab = require('./tab');

Object.defineProperty(exports, 'MDCTabFoundation', {
  enumerable: true,
  get: function get() {
    return _tab.MDCTabFoundation;
  }
});
Object.defineProperty(exports, 'MDCTab', {
  enumerable: true,
  get: function get() {
    return _tab.MDCTab;
  }
});

var _tabBar = require('./tab-bar');

Object.defineProperty(exports, 'MDCTabBarFoundation', {
  enumerable: true,
  get: function get() {
    return _tabBar.MDCTabBarFoundation;
  }
});
Object.defineProperty(exports, 'MDCTabBar', {
  enumerable: true,
  get: function get() {
    return _tabBar.MDCTabBar;
  }
});

var _tabBarScroller = require('./tab-bar-scroller');

Object.defineProperty(exports, 'MDCTabBarScrollerFoundation', {
  enumerable: true,
  get: function get() {
    return _tabBarScroller.MDCTabBarScrollerFoundation;
  }
});
Object.defineProperty(exports, 'MDCTabBarScroller', {
  enumerable: true,
  get: function get() {
    return _tabBarScroller.MDCTabBarScroller;
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material/tabs/index.js
// module id = 1305
// module chunks = 0